import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function ContactForm() {
  const [status, setStatus] = useState(null);
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Honeypot field */}
      <div className="sr-only absolute" aria-hidden="true">
        <input
          type="text"
          name="website_url"
          tabIndex="-1"
          autoComplete="off"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <label htmlFor="name" className="block text-sm font-bold uppercase tracking-widest text-slate-900 mb-2">
            {t('contactForm.nameLabel')}
          </label>
          <input
            type="text"
            name="name"
            id="name"
            required
            className="w-full bg-transparent border-b-2 border-slate-300 focus:border-blue-700 py-3 outline-none transition-colors"
            placeholder={t('contactForm.namePlaceholder')}
          />
        </div>
        <div>
          <label htmlFor="phone" className="block text-sm font-bold uppercase tracking-widest text-slate-900 mb-2">
            {t('contactForm.phoneLabel')}
          </label>
          <input
            type="tel"
            name="phone"
            id="phone"
            required
            className="w-full bg-transparent border-b-2 border-slate-300 focus:border-blue-700 py-3 outline-none transition-colors"
            placeholder={t('contactForm.phonePlaceholder')}
          />
        </div>
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-bold uppercase tracking-widest text-slate-900 mb-2">
          {t('contactForm.emailLabel')}
        </label>
        <input
          type="email"
          name="email"
          id="email"
          required
          className="w-full bg-transparent border-b-2 border-slate-300 focus:border-blue-700 py-3 outline-none transition-colors"
          placeholder={t('contactForm.emailPlaceholder')}
        />
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-bold uppercase tracking-widest text-slate-900 mb-2">
          {t('contactForm.messageLabel')}
        </label>
        <textarea
          name="message"
          id="message"
          rows="4"
          required
          className="w-full bg-transparent border-b-2 border-slate-300 focus:border-blue-700 py-3 outline-none transition-colors resize-none"
          placeholder={t('contactForm.messagePlaceholder')}
        ></textarea>
      </div>

      <div>
        <button
          type="submit"
          className="bg-blue-700 text-white px-10 py-4 uppercase font-bold tracking-widest text-sm hover:bg-blue-800 transition-colors cursor-pointer"
        >
          {t('contactForm.submitBtn')}
        </button>
      </div>

      {status === 'success' && (
        <p className="text-green-600 font-medium">{t('contactForm.successMsg')}</p>
      )}
      {status === 'error' && (
        <p className="text-red-600 font-medium">{t('contactForm.errorMsg')}</p>
      )}
    </form>
  );
}
